export const FLAG_GETTING_TOLLS = 'FLAG_GETTING_TOLLS';
export const GET_TOLLS = 'GET_TOLLS';
export const CLEAR_TOLLS = 'CLEAR_TOLLS';
export const FLAG_TOLL_ACTIVITY = 'FLAG_TOLL_ACTIVITY';
export const GET_TOLL = 'GET_TOLL';
export const CLEAR_TOLL = 'CLEAR_TOLL';
